import { memoize, merge } from 'lodash';

import { post } from '../../01-helpers/services/ajax';

const defaultParams = {};

let getFriends;

export default getFriends = memoize(data => {
    return post(
	    '/api/teetimes/getfriends',
        {
            // add data to api call
			data: merge({}, defaultParams, data)
        }
    );
});